import React from 'react';
import points from '../../../../utils/polygonPoints';
import './Hero.css';

// @TODO: hard coded content which will need to be refactored for CMS integration
const Hero = () => {

    const color1 = 'rgba(255,255,255, 0.2)';
    const color2 = '#26588D';
    const color3 = 'rgba(255,255,255, 0.3)';
    const color4 = 'transparent';

    return (
        <section className="hero news-hero">
            <div className="svg-triangle">
                <svg preserveAspectRatio="none" viewBox="0 0 80 100">
                    <polygon
                        className="filled-polygon"
                        points={points.hero.top}
                        opacity=".7"
                        fill="url(#white-to-dark-blue)">
                    </polygon>
                    <defs>
                        <linearGradient id="white-to-dark-blue">
                            <stop offset="0" stopColor={color1} />
                            <stop offset=".3" stopColor={color2} />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="svg-triangle">
                <svg preserveAspectRatio="none" viewBox="0 0 80 100">
                    <polygon
                        className="filled-polygon-transparent"
                        points={points.hero.bottom} opacity="0.7"
                        fill="url(#white-to-transparent)">
                    </polygon>
                    <defs>
                        <linearGradient id="white-to-transparent">
                            <stop offset=".25" stopColor={color3} />
                            <stop offset=".60" stopColor={color4} />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-offset-1-tablet is-10-tablet is-11-desktop is-three-fifths-widescreen">
                            <div className="title-wrapper animated fadeInLeft">
                                <h1 className="hidden">Hudson Pacific Properties News</h1>
                                <div className="pre-title">PRESS & INSIGHTS</div>
                                <div className="big-title">
                                    Find out what’s<br /> trending at<br /> Hudson Pacific
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
